import {
  Request
} from '../index'

/* 差旅标准 */
export function kpiHomsomRankCar(data = {}) {
  return Request('homsomRank/carv3', 'post', undefined, data)
}

/* 预估价格 */
export function kpiCarOrderEstimatePrice(data = {}) {
  return Request('car/Order/EstimatePrice', 'post', undefined, data)
}

/* 订单初始化 */
export function kpiCarOrderInit(data = {}) {
  return Request('car/Order/Init', 'post', undefined, data)
}

/** 获取火车站站点 */
export function kpiQueryTrainStation(data = {}) {
  return Request('car/Search/QueryTrainStation', 'post', undefined, data)
}
/** 获取机场 */
export function kpiQueryAirport(data = {}) {
  return Request('car/Search/QueryAirport', 'post', undefined, data)
}

/** 根据出发地目的地 查询航班列表 */
export function kpiQueryFlightQuery(data = {}) {
  return Request('car/Query/FlightQuery', 'post', undefined, data)
}

/** 根据出发地目的地 查询航班列表 */
export function kpiQueryQueryByFlightNo(data = {}) {
  return Request('car/Query/QueryByFlightNo', 'post', undefined, data)
}

/** 查询已开通城市列表 */
export function kpiCarCityAvailableList(data = {}) {
  return Request('car/City/AvailableList', 'post', undefined, data)
}

/** 用车选择城市 城市查询 */
export function kpiCarCityQuery(data = {}) {
  return Request('car/City/Query', 'post', undefined, data)
}

/* 校验ReasonCode */
export function kpiCarOrderValidatePassengerRanks(data = {}) {
  return Request('car/Order/ValidatePassengerRanks', 'post', undefined, data)
}

/* 检测订单重复 */
export function kpiCarOrderCheckOrderRepeat(data = {}) {
  return Request('car/Order/CheckOrderRepeat', 'post', undefined, data)
}

/* 提交订单 */
export function kpiCarOrderOrderSubmit(data = {}) {
  return Request('car/Order/OrderSubmit', 'post', undefined, data)
}

/* 取消订单 */
export function kpiCarOrderOrderCancel(data = {}) {
  return Request('car/Order/OrderCancel', 'post', undefined, data)
}
/**
 * 获取用车申请单信息
 */
export function kpiMcarGetAuthorizationInfo(data = {}) {
  return Request(`mcar/getAuthorizationInfo`, 'post', undefined, data)
}

/**
 * 获取紧急联系人
 */
export function kpiCarEmergencyGet(data = {}) {
  return Request(`car/Emergency/Get`, 'post', undefined, data)
}
/**
 * 添加紧急联系人
 */
export function kpiCarEmergencySet(data = {}) {
  return Request(`car/Emergency/Set`, 'post', undefined, data)
}
/**
 * 删除紧急联系人
 */
export function kpiCarEmergencyDelete(data = {}) {
  return Request(`car/Emergency/Delete`, 'post', undefined, data)
}

/**
 * 获取收藏点
 */
export function kpiCarFavoriteAddressGet(data = {}) {
  return Request(`car/FavoriteAddress/Get`, 'post', undefined, data)
}

/**
 * 设置收藏点
 */
export function kpiCarFavoriteAddressSet(data = {}) {
  return Request(`car/FavoriteAddress/Set`, 'post', undefined, data)
}

/**
 * 删除收藏点
 */
export function kpiCarFavoriteAddressDelete(data = {}) {
  return Request(`car/FavoriteAddress/Delete`, 'post', undefined, data)
}

/**
 * 获取用车场景
 */
export function kpiHomsomRankCarScene(data = {}) {
  return Request(`homsomRank/carSetting`, 'post', undefined, data)
}

/**
 * 安全中心发送短信
 */
export function kpiEmergencySendMessage(data = {}) {
  return Request(`car/Emergency/SendMessage`, 'post', undefined, data)
}

/**
 * 用车--获取当前订单
 */
export function kpiGetTravelingOrder(data = {}) {
  return Request(`car/Order/GetTravelingOrder`, 'post', undefined, data)
}
/**
 * 用车--查询订单实时状态
 */
export function kpiCarOrderGetOrderStatus(data = {}) {
  return Request(`car/Order/GetOrderStatus`, 'post', undefined, data, false, true)
}

/**
 * 用车--高德搜索查询
 */
export function kpiCarSearchKeywordSearch(data = {}) {
  return Request(`car/Search/KeywordSearch`, 'post', undefined, data, false, true)
}

/**
 * 用车--坐标位置查询
 */
export function kpiCarSearchLocationSearch(data = {}) {
  return Request(`car/Search/LocationSearch`, 'post', undefined, data, false, true)
}

/**
 * 用车--坐标位置查询
 */
export function kpiCarSearchLocationSearchNotCancel(data = {}) {
  return Request(`car/Search/LocationSearch?type=location`, 'post', undefined, data, false, true)
}

/**
 * 用车--查询电子围栏信息
 */
export function kpiCarSearchFenceSearch(data = {}) {
  return Request(`car/Search/FenceSearch`, 'post', undefined, data, false, true)
}

/**
 * 用车--热门地点
 */
export function kpiCarSearchHotSpots(data = {}) {
  return Request(`car/Search/HotSpots`, 'post', undefined, data, false, true)
}
/**
 * 用车--获取用车操作地址
 */
export function kpiCarGetOperationUrl(data = {}) {
  return Request(`car/Order/GetOperationUrl`, 'post', undefined, data, false, true)
}
